<template>
    <div dir="ltr">
  <router-view></router-view>
  <set-address-profile 
      v-model="showAddressPopup" 
      @success="onAddressSuccess" 
    />
</div>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "assets/css/style.vue.rtl";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
</style>

<script>
import {OVERRIDE_LAYOUT_CONFIG} from "@/core/services/store/config.module";
import {rbAxios, RobotAxios, SmsAxios} from "@/main";
import setAddressProfile from "./core/plugins/TitleRibbon/setAddressProfile.vue";

window.$ = window.jquery = window.jQuery = require("jquery");
export default {
  components:{setAddressProfile},
  name: "MetronicVue",
  mounted() {
    this.$api.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem('id_token')}`
    rbAxios.defaults.headers['Authorization'] = localStorage.getItem('id_token')
    RobotAxios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem('id_token')}`
    SmsAxios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem('id_token')}`
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
      this.$root.$on("open-address-popup", () => {
      this.showAddressPopup = true;
    });

  },
    data(){
    return{
      showAddressPopup: false,
    }
  },
  methods:{
     onAddressSuccess() {
      console.log("آدرس با موفقیت ثبت شد");
    }
  },
  beforeDestroy() {
    this.$root.$off("open-address-popup");
  },


};
</script>
